import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql, useStaticQuery } from 'gatsby'
import { LANGUAGES } from '../constants'
import AndroidFaviconSmall from '../assets/favicon_io/android-chrome-192x192.png'
import AndroidFavicon from '../assets/favicon_io/android-chrome-512x512.png'
import AppleTouchIcon from '../assets/favicon_io/apple-touch-icon.png'
import FaviconSmall from '../assets/favicon_io/favicon-16x16.png'
import FaviconPng from '../assets/favicon_io/favicon-32x32.png'
import Favicon from '../assets/favicon_io/favicon.ico'
import MetaThumb from '../assets/images/JB-meta.jpg'

const SITE_TWITTER_HANDLE = '@jbapp_'
const SEO = ({
  language,
  title,
  metaDescription: description,
  metaTag,
  theme,
  location,
}) => {
  const { site } = useStaticQuery(graphql`
    query DefaultSEOQuery {
      site {
        siteMetadata {
          title
          titleAr
          description
          author
        }
      }
    }
  `)
  const siteDescription = site.siteMetadata?.description || ''
  const metaDescription = `${siteDescription} ${description}`
  const defaultTitle =
    (language === LANGUAGES.EN
      ? site.siteMetadata?.title
      : site.siteMetadata?.titleAr) || 'JB'

  const keywords = [metaTag]
  const url = location?.href || ''
  const displayTitle = title ? `${defaultTitle} | ${title}` : defaultTitle
  const meta = [
    {
      name: `viewport`,
      content: 'minimum-scale=1, initial-scale=1, width=device-width',
    },
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      property: `og:site_name`,
      content: displayTitle,
    },
    {
      property: `og:title`,
      content: displayTitle,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:url`,
      content: url,
    },
    {
      property: `og:image`,
      content: MetaThumb,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:creator`,
      content: site.siteMetadata?.author || ``,
    },
    {
      name: `twitter:title`,
      content: displayTitle,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    {
      name: `twitter:site`,
      content: `${SITE_TWITTER_HANDLE}`,
    },
    {
      name: `twitter:image`,
      content: MetaThumb,
    },
    {
      name: `twitter:image:alt`,
      content: displayTitle,
    },
    {
      name: `theme-color`,
      content: theme?.palette?.background?.default,
    },
    {
      name: `image`,
      content: MetaThumb,
    },
    // for mobile browsers header bar
    {
      name: `apple-mobile-web-app-capable`,
      content: `yes`,
    },
    {
      name: `apple-mobile-web-app-status-bar-style`,
      content: `default`,
    },
  ].concat(
    keywords.length > 0
      ? {
          name: `keywords`,
          content: keywords.join(`, `),
        }
      : [],
  )
  return (
    <Helmet
      htmlAttributes={{
        lang: language,
      }}
      bodyAttributes={{
        dir: language === LANGUAGES.EN ? 'ltr' : 'rtl',
      }}
      title={displayTitle}
      meta={meta}
    >
      <link rel="stylesheet" href="https://use.typekit.net/wxd4lun.css" />
      <link rel="apple-touch-icon" sizes="180x180" href={AppleTouchIcon} />
      <link rel="icon" type="image/png" sizes="32x32" href={FaviconPng} />
      <link rel="icon" type="image/png" sizes="16x16" href={FaviconSmall} />
      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href={AndroidFaviconSmall}
      />
      <link rel="icon" type="image/png" sizes="512x512" href={AndroidFavicon} />
      <link rel="icon" type="image/x-icon" href={Favicon} />
    </Helmet>
  )
}
export default SEO
